import { SticketSvgProps } from './types';
const SticketSvg = ({ bgColor = '#ffffff' }: SticketSvgProps) => (
  <svg
    width="1.625rem"
    height="1.625rem"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#000000"
    strokeWidth={1}
    strokeLinecap="square"
    strokeLinejoin="miter"
    fill="none"
    color="#000000"
    aria-labelledby="stickerIconTitle"
  >
    <title id="stickerIconTitle">{'Sticker'}</title>
    <path
      d="M21,3 L21,11 C21,16.5228475 16.5228475,21 11,21 L3,21 L3,3 L21,3 Z"
      fill={bgColor}
      stroke="#000000"
    />
    <path
      d="M9,21 C11.6667,21 13,19.6667 13,17 C13,17 13,15.6667 13,13 L17,13 C19.6667,13 21,11.6667 21,9"
      stroke="#000000"
      fill="none"
    />
    <path
      d="M12 6V10"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 8H14"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SticketSvg;
